import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import BeneficioModel from "@/models/beneficio/beneficioModel";
import beneficioService from "@/services/beneficioService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component
export default class BeneficiosListComponent extends ListComponentBase<BeneficioModel> {
    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("descricao", "Descrição", GridColumnType.String)];
    }

    private beforeMount() {
        this.setPropsCached(beneficioService, "beneficio", "descricao", true);
    }
}
